module.exports = __webpack_public_path__ + "static/media/art-min.b1057331.jpg";